var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatrixIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3969 0.333313L37 18.4867L18.9365 37L0.333374 18.8466L18.3969 0.333313ZM31.765 4.99384L31.6014 11.8461L24.9296 5.49577L31.765 4.99384ZM11.6511 6.41947L4.80919 6.01525L5.07068 12.8645L11.6511 6.41947ZM5.726 32.1102L6.0775 25.2649L12.5726 31.7959L5.726 32.1102ZM25.9224 30.8764L32.7714 31.1341L32.3634 24.292L25.9224 30.8764Z",
    fill: "#C0B9F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrixIcon);
export default __webpack_public_path__ + "static/media/matrix-icon.47b3c5ca3ee4515c6095b41eecce3a3b.svg";
export { ForwardRef as ReactComponent };